export enum FundingBatchDetailStatus {
    /** 0 */
    UNKNOWN_FUNDING_STATUS = 'UNKNOWN_FUNDING_STATUS',
    /** 1 */
    STAGED = 'STAGED',
    /** 2 */
    REJECTED = 'REJECTED',
    /** 3 */
    SENT = 'SENT',
    /** 4 */
    IN_TRANSFER = 'IN_TRANSFER',
    /** 5 */
    CANCELLED = 'CANCELLED',
    /** 6 */
    SCHEDULED = 'SCHEDULED',
    /** 7 */
    PAID = 'PAID',
    /** 8 */
    APPROVED = 'APPROVED'
}
